//  SessionContext.js
//
//  Updated 2/26.
//
//  Abstract: User authentication context solely within dashboard component.

import React, { createContext, useState } from 'react';

const SessionContext = createContext();

function SessionProvider(props) {

    const [ username, setUsername ] = useState('');
    //  TODO

    const values = {
        username,
    }

    return (
        <>
        <SessionContext.Provider value={values}>
            {props.children}
        </SessionContext.Provider>
        </>
    );
}

export { SessionContext, SessionProvider };